/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, total: NonNullable<unknown> }} Receipt_Change_Members_RemovedInputs */



/**
* | output |
* | --- |
* | "Members −{count} → {total}" |
*
* @param {Receipt_Change_Members_RemovedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_change_members_removed = /** @type {((inputs: Receipt_Change_Members_RemovedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Change_Members_RemovedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Mitglieder −${i?.count} → ${i?.total}`)
	return /** @type {LocalizedString} */ (`Members −${i?.count} → ${i?.total}`)
});